// extracted by mini-css-extract-plugin
module.exports = {"container":"TabsHeader_container_YLkgz","tab":"TabsHeader_tab_2uzSr","tabActive":"TabsHeader_tabActive_16i24","button":"TabsHeader_button_1Q9a1"};